
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import Pagination from "@/comp/Pagination/index.vue";
import { imScoreList, imScoreSave, imScoreLogList } from "@/api/request/user";
import { parseTime } from "@/utils";

//组件
@Component({
  name: "ImScore",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = true;

  //请求数据
  private listQuery: any = {
    //页面数据
    page: 0,
    page_size: 20,

    //临时数据
    user_id_str: "",

    //筛选数据
    user_id: 0,
    user_type: -1,
  };

  //类型列表
  private typeList: any[] = [
    { type: -1, name: "全部类型" },
    { type: 0, name: "用户" },
    { type: 1, name: "博主" },
  ];

  //创建
  created() {
    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    this.listQuery.user_id = Number(this.listQuery.user_id_str);

    //获取数据
    const { data } = await imScoreList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取数据
    this.getList();
  }

  //显示设置
  private handleShowSet(row: any): void {
    //数据赋值
    this.setQuery = {
      user_id: row.id,
      score: row.score,
    };

    //显示界面
    this.setDialog = true;
  }

  //显示变更记录
  private handleShowLogList(row: any): void {
    //数据赋值
    this.logListQuery = {
      //请求数据
      page: 1, //当前页
      page_size: 10, //页大小
      user_id: row.id, //用户ID
    };

    //显示界面
    this.logListDialog = true;

    //获取列表
    this.getLogList();
  }

  //获取时间文本
  private getTimeStr(time: number): string {
    //返回时间文本
    return parseTime(time) as string;
  }

  //------------------------------- 设置界面 -------------------------------
  //定义变量
  private setDialog: boolean = false;
  private setLoading: boolean = false;

  //用户类型
  private setQuery: any = {
    //请求数据
    score: 1,
    user_id: 0,
  };

  //用户类型
  private scoreList: any[] = [
    { value: -10, label: "-10" },
    { value: -9, label: "-9" },
    { value: -8, label: "-8" },
    { value: -7, label: "-7" },
    { value: -6, label: "-6" },
    { value: -5, label: "-5" },
    { value: -4, label: "-4" },
    { value: -3, label: "-3" },
    { value: -2, label: "-2" },
    { value: -1, label: "-1" },
    { value: 0, label: "0" },
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
    { value: 6, label: "6" },
    { value: 7, label: "7" },
    { value: 8, label: "8" },
    { value: 9, label: "9" },
    { value: 10, label: "10" },
  ];

  //关闭类型
  private setDialogClose(): void {
    //隐藏对话框
    this.setDialog = false;
  }

  //设置评分
  private async setDialogConfirm() {
    //显示等待
    this.setLoading = true;

    //请求数据
    const data = await imScoreSave(this.setQuery);

    //设置成功
    if (data.status === 0) {
      //显示提示
      this.$message.success(`设置成功`);

      //获取数据
      this.getList();
    }

    //显示等待
    this.setLoading = false;

    //隐藏界面
    this.setDialog = false;
  }

  //------------------------------- 变更记录 -------------------------------
  //定义变量
  private logList: any[] = [];
  private logTotal: number = 0;
  private logListDialog: boolean = false;
  private logListLoading: boolean = false;

  //用户类型
  private logListQuery: any = {
    //请求数据
    page: 1, //当前页
    page_size: 10, //页大小
    user_id: 0, //用户ID
  };

  //获取变更记录
  private async getLogList() {
    //显示等待
    this.logListLoading = true;

    //获取数据
    const { data } = await imScoreLogList(this.logListQuery);

    //数据赋值
    this.logList = data.list;
    this.logTotal = data.total;

    //隐藏等待
    setTimeout(() => {
      this.logListLoading = false;
    }, 0.5 * 1000);
  }

  //关闭变更记录
  private logListDialogClose(): void {
    //隐藏界面

    this.logListDialog = false;
  }
}
